// MessageBubble component constants and configuration

export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🎉'];

export const MESSAGE_TYPES = {
  ERROR: 'error',
  DELETED: 'deleted',
  REGULAR: 'regular'
};

export const ATTACHMENT_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  PDF: 'pdf',
  DOCUMENT: 'document'
};

export const MESSAGE_STATUS = {
  SENDING: 'sending',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read'
};

export const MAX_MESSAGE_WIDTH = {
  MOBILE: 'max-w-[280px] sm:max-w-xs',
  DESKTOP: 'lg:max-w-md xl:max-w-lg'
};

export const TOUCH_TARGETS = {
  MIN_SIZE: 'min-h-[44px] min-w-[44px]', // 44px minimum for accessibility
  BUTTON_PADDING: 'p-3', // Increased padding for touch
  REACTION_SIZE: 'w-8 h-8' // Larger reaction buttons
};

export const MESSAGE_CLASSES = {
  OWN_MESSAGE: 'bg-accent text-primary rounded-br-md',
  OTHER_MESSAGE: 'bg-surface text-text-primary border border-accent/20 rounded-bl-md',
  ERROR_MESSAGE: 'bg-warning/20 border border-warning/40 text-warning',
  DELETED_MESSAGE: 'bg-surface/50 text-text-secondary border border-accent/10 rounded-bl-md opacity-60 italic',
  DECRYPTION_FAILED: 'bg-warning/20 border border-warning/40 text-warning rounded-lg px-3 py-2',
  FIRST_IN_GROUP: 'mt-1',
  NOT_FIRST_IN_GROUP: 'mt-0'
};

export const BUTTON_CLASSES = {
  REACTION: 'bg-surface border border-accent/20 rounded-full px-2 py-0.5 text-xs hover:bg-accent/10 transition-colors',
  ACTION: 'p-2 hover:bg-accent/20 rounded-full text-text-secondary hover:text-accent transition-colors',
  DECRYPT: 'px-3 py-1 bg-accent text-white text-xs rounded hover:bg-accent/80 disabled:opacity-50'
};

export const LAYOUT_CLASSES = {
  CONTAINER: 'flex items-end mb-1',
  BUBBLE_CONTAINER: 'flex flex-col',
  ATTACHMENT_CONTAINER: 'mb-2',
  REACTIONS_CONTAINER: 'flex flex-wrap gap-1 mt-1',
  TIME_STATUS_CONTAINER: 'flex items-center mt-1',
  ACTION_MENU: 'flex items-center space-x-1 z-40 relative',
  QUICK_REACTIONS_POPUP: 'absolute bottom-full mb-2 bg-surface border border-accent/30 rounded-lg p-2 shadow-lg z-50 whitespace-nowrap'
};

export const ICONS = {
  LOCK: '🔒',
  DOCUMENT: '📄',
  ATTACHMENT: '📎',
  READ_RECEIPT_SINGLE: '✓',
  READ_RECEIPT_DOUBLE: '✓✓'
};

export const ERROR_MESSAGES = {
  ATTACHMENT_DECRYPT_FAILED: 'Failed to decrypt attachment. Please try again.',
  MESSAGE_DELETE_FAILED: 'Failed to delete message',
  FAVORITE_FAILED: 'Error marking favorite',
  REACTION_FAILED: 'Error adding reaction',
  TIME_FORMAT_ERROR: 'Error formatting time'
};

export const SUCCESS_MESSAGES = {
  ATTACHMENT_DECRYPTED: 'Attachment decrypted successfully',
  MESSAGE_DELETED: 'Message deleted successfully',
  FAVORITE_ADDED: 'Added to favorites',
  FAVORITE_REMOVED: 'Removed from favorites'
};

export const ARIA_LABELS = {
  MESSAGE_BUBBLE: 'Message bubble',
  ATTACHMENT_BUTTON: 'Decrypt and view attachment',
  REACTION_BUTTON: (emoji, count) => `React with ${emoji}${count > 1 ? ` (${count} reactions)` : ''}`,
  ADD_REACTION: 'Add reaction',
  CONTEXT_MENU: 'Message options',
  FAVORITE_BUTTON: (isFavorite) => isFavorite ? 'Unfavorite message' : 'Favorite message',
  COPY_BUTTON: 'Copy message',
  DELETE_BUTTON: 'Delete message'
};

export const KEYBOARD_SHORTCUTS = {
  COPY: 'Control+c',
  DELETE: 'Delete',
  FAVORITE: 'Control+f'
};

export const Z_INDEX = {
  CONTEXT_MENU: 50,
  REACTIONS_POPUP: 50,
  ACTION_MENU: 40
};

export const LOADING_STATES = {
  SPINNER: 'animate-spin w-4 h-4 border-2 border-gray-300 border-t-accent rounded-full',
  PULSE: 'animate-pulse bg-gray-200',
  SKELETON: 'animate-pulse bg-surface rounded'
};

export const TRANSITIONS = {
  FADE_IN: 'transition-opacity duration-200 opacity-0 animate-in fade-in',
  SLIDE_UP: 'transition-transform duration-200 transform translate-y-2 animate-in slide-in-from-bottom-2',
  SCALE_IN: 'transition-transform duration-150 transform scale-95 animate-in zoom-in-95'
};

